import React from "react";
import Grid from "@mui/material/Grid";
import { ItemStatus, ItemStatusProps } from "./itemStatus";
import { ItemActions, ItemActiosProps } from "./itemActions";
import { MobileHeader } from "./mobileHeader";

interface TopBarProps {
  mobileView: boolean;
  actions?: ItemActiosProps;
  itemStatus?: ItemStatusProps | boolean;
  brandLogoIMG?: string | undefined;
}

function TopBar({ mobileView, actions, itemStatus, brandLogoIMG }: TopBarProps) {
  const [isScrolled, setIsScrolled] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Grid size={12} sx={{
      position: 'sticky',
      top: '10px',
      zIndex: 1000,
    }}>
      {mobileView && <MobileHeader actions={actions} itemStatus={itemStatus as ItemStatusProps} />}
      <Grid size={12} sx={{
        transition: 'all 0.3s ease-in-out',
        display: 'flex',
        justifyContent: 'flex-end',
      }}>
        <Grid sx={{
          width: isScrolled ? '80%' : '100%',
          transition: 'all 0.3s ease-in-out',
        }}>
          {actions && !mobileView && <ItemActions {...actions} brandLogoIMG={brandLogoIMG} />}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default TopBar; 